import React from 'react';

interface CenteredCheckboxProps {
  id: string;
  name: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}

const CenteredCheckbox: React.FC<CenteredCheckboxProps> = ({
  id,
  name,
  checked,
  onChange,
  children,
  required = false,
  className = ''
}) => {
  return (
    <div className={`flex items-start ${className}`}>
      <input 
        type="checkbox" 
        id={id} 
        name={name}
        checked={checked}
        onChange={onChange}
        required={required}
        className="mt-1 h-4 w-4 text-gray-800 border-gray-300 rounded focus:ring-gray-800"
      />
      <label htmlFor={id} className="ml-3 text-sm text-gray-600">
        {children}
      </label>
    </div>
  );
};

export default CenteredCheckbox;
